<template>
  <div class="chart-item">
    <h2 class="trading-title">{{ $t('Funding Rate History') }}</h2>
    <div class="chart-item-container">
      <div class="chart-item-filter-item">
        <span class="report-filter-item-title">{{ $t('type') }}</span>
        <CustomSelect
            custom-class="support-form"
            :options="typeOptionsList"
            default="BTC/USDT"
            @update:modelValue="type = $event"
        />
      </div>
      <time-frame
          :periods="periods"
          :dimension="dimension"
          @selectedPeriod="dimension = $event"
      >
      </time-frame>
    </div>
    <div class="content-wrapper">
      <div class="preloader new-preloader" v-if="isLoading">
        <lottie-animation
            ref="preloader"
            :animationData="require('@/assets/img/Loader.json')"
            :loop="true"
            :autoPlay="true"
            :speed="1"
        />
      </div>
      <template v-else-if="fundingRateHistoryData.length">
        <highcharts
            :updateArgs="updateArgs"
            :options="chartOptionsFundingRateHistory"
        />
        <div class="chart-item-table">
          <table>
            <thead>
            <tr>
              <th class="funding-time">
                {{ $t('time') }}
              </th>
              <th class="funding-interval">
                {{ $t('Funding Interval') }}
              </th>
              <th class="interest-rate">
                {{ $t('Interest Rate') }}
              </th>
              <th class="funding-rate">
                {{ $t('Funding Rate') }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(item, index) in fundingRateHistoryData"
                :key="index"
                class="table-body"
            >
              <td class="funding-time">{{ formatter(item.time) }}</td>
              <td class="funding-interval">8h</td>
              <td class="interest-rate">{{ item.interestRate }}</td>
              <td
                  class="funding-rate"
                  :style="{color: item.fundingRate > 0  ? '#1BB8B0' : '#F27870'}"
              >{{ item.fundingRate }}</td>
            </tr>
            </tbody>
          </table>
        </div>
<!--        <b-pagination-nav-->
<!--            v-if="fundingRateHistoryData.length && count !== 1"-->
<!--            class="pagination"-->
<!--            v-model="page"-->
<!--            :total-rows="count"-->
<!--            :per-page="pageSize"-->
<!--            :link-gen="linkGen"-->
<!--            :number-of-pages="count"-->
<!--            prev-text="«"-->
<!--            next-text="»"-->
<!--            first-number-->
<!--            last-number-->
<!--            use-router-->
<!--        />-->
      </template>
      <div v-else class="report-empty-list">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M42.1351 5.89334C41.0418 4.8 39.1484 5.54667 39.1484 7.06667V16.3733C39.1484 20.2667 42.4551 23.4933 46.4818 23.4933C49.0151 23.52 52.5351 23.52 55.5484 23.52C57.0684 23.52 57.8684 21.7333 56.8018 20.6667C52.9618 16.8 46.0818 9.84 42.1351 5.89334Z" fill="#92939C"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M46.9613 27.1733H54.668C56.1346 27.1733 57.3346 28.3733 57.3346 29.84V39.6441C55.2687 38.1884 52.7495 37.3333 50.0315 37.3333C43.0218 37.3333 37.3346 43.0205 37.3346 50.0302C37.3346 53.365 38.6218 56.4005 40.7262 58.6666H21.5213C13.308 58.6666 6.66797 53.3333 6.66797 43.8133V20.1866C6.66797 10.6666 13.308 5.33331 21.5213 5.33331H32.828C34.2946 5.33331 35.4946 6.53331 35.4946 7.99998V15.7066C35.4946 22.0266 40.6413 27.1733 46.9613 27.1733ZM57.3346 43.755V43.8133C57.3346 52.1992 52.1825 57.3365 45.3411 58.4415C42.3948 56.7941 40.4015 53.6436 40.4015 50.0302C40.4015 44.7143 44.7156 40.4002 50.0315 40.4002C52.9509 40.4002 55.5682 41.7013 57.3346 43.755ZM20.0013 47.3333H30.668C31.7613 47.3333 32.668 46.4266 32.668 45.3333C32.668 44.24 31.7613 43.3333 30.668 43.3333H20.0013C18.908 43.3333 18.0013 44.24 18.0013 45.3333C18.0013 46.4266 18.908 47.3333 20.0013 47.3333ZM20.0013 36.6666H36.0013C37.0946 36.6666 38.0013 35.76 38.0013 34.6666C38.0013 33.5733 37.0946 32.6666 36.0013 32.6666H20.0013C18.908 32.6666 18.0013 33.5733 18.0013 34.6666C18.0013 35.76 18.908 36.6666 20.0013 36.6666Z" fill="#92939C"/>
          <path d="M59.9855 57.2476L58.0636 55.3257C59.0655 53.8127 59.6584 51.993 59.6584 50.0302C59.6584 44.7143 55.3443 40.4002 50.0284 40.4002C44.7125 40.4002 40.3984 44.7143 40.3984 50.0302C40.3984 55.3461 44.7125 59.6602 50.0284 59.6602C51.9912 59.6602 53.7905 59.0672 55.3239 58.0654L57.2458 59.9873C57.6343 60.3758 58.125 60.5598 58.6361 60.5598C59.1473 60.5598 59.638 60.3758 60.0264 59.9873C60.742 59.2513 60.742 58.0245 59.9855 57.2476Z" fill="#92939C"/>
        </svg>
        <p class="secondary-text holder-not-logged-text">{{ $t('No records found') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import LottieAnimation from "lottie-web-vue";
import CustomSelect from '@/components/inputs/CustomSelect';
import { mapActions } from 'vuex';
import TimeFrame from '@/components/time-frame/TimeFrame';
import moment from 'moment';
import { Chart } from 'highcharts-vue';
import numeral from "numeral";

export default {
  name: 'FundingRateHistory',
  data() {
    return {
      page: 1,
      size: 8,
      count: 2,
      pageSize: 2,
      sortBy: '',
      periods: [
        {
          buttonText: 'Last 7 Days',
          dimension: 'DAYS_7'
        },
        {
          buttonText: 'Last 14 Days',
          dimension: 'DAYS_14'
        },
      ],
      updateArgs: [true, true, true],
      isLoading: false,
      fundingRateHistoryData: [],
      fundingRateHistoryDataTime: [],
      fundingRateHistory: [],
      symbol: 'btc_usdt',
      dimension: 'DAYS_7',
      typeOptionsList: [
        {
          name: 'BTC/USDT',
          value: 'btc_usdt',
        },
        {
          name: 'ETH/USDT',
          value: 'eth_usdt',
        },
        {
          name: 'SOL/USDT',
          value: 'sol_usdt',
        },
        {
          name: 'ADA/USDT',
          value: 'ada_usdt',
        },
        {
          name: 'NEAR/USDT',
          value: 'near_usdt',
        },
        {
          name: 'APE/USDT',
          value: 'ape_usdt',
        },
        {
          name: 'ATOM/USDT',
          value: 'atom_usdt',
        },
        {
          name: 'AVAX/USDT',
          value: 'avax_usdt',
        },
        {
          name: 'DOT/USDT',
          value: 'dot_usdt',
        },
        {
          name: 'GMT/USDT',
          value: 'gmt_usdt',
        },
        {
          name: 'MATIC/USDT',
          value: 'matic_usdt',
        },
      ],
      type: null,
      chartOptionsFundingRateHistory: {
        title: null,
        credits: {
          enabled: false
        },
        chart: {
          backgroundColor: this.$vuetify.theme.dark,
          height: 350,
          marginTop: 70,
          zoomType: 'x',
        },
        xAxis: [
          {
            categories: this.fundingRateHistoryDataTime,
            labels: {
              step: 3,
              style: {
                'color': '#92939c',
                'cursor': 'pointer',
                'fontSize': '11px',
                'lineHeight': '16px',
                'fontWeight': '400',
                'textOverflow': 'ellipsis'
              },
              formatter: function () {
                return moment.utc(this.value).format('HH:mm') + '<br>' +  moment.utc(this.value).format('MM/DD');
              }
            },
            lineColor: 'var(--v-graphBottomLine-base)',
          }],
        plotOptions: {
          areaspline: {
            fillOpacity: 0.5,
          }
        },
        tooltip: {
          shared: true,
        },
        yAxis: [
          {
            title: {
              text: '',
            },
            labels: {
              style: {
                'color': '#92939c',
                'cursor': 'pointer',
                'fontSize': '11px',
                'lineHeight': '16px',
                'fontWeight': '400',
                'textOverflow': 'ellipsis'
              },
            },
            gridLineColor: 'var(--v-graphBackgroundLineColor-base)',
            lineColor: 'var(--v-graphBackgroundLineColor-base)',
            minorGridLineColor: 'var(--v-graphBackgroundLineColor-base)',
            tickColor: 'var(--v-graphBackgroundLineColor-base)',
            plotLines: [{
              color: 'var(--v-graphBackgroundLineColor-base)'
            }],
          },

        ],
        legend: {
          enabled: false,
          align: 'center',
          itemStyle: {
            'color': '#E9E9E9',
            'cursor': 'pointer',
            'fontSize': '12px',
            'lineHeight': '18px',
            'fontWeight': 'normal',
            'textOverflow': 'ellipsis'
          },
          itemHoverStyle: {
            'color': '#42E8E0',
            'cursor': 'pointer',
            'fontSize': '12px',
            'lineHeight': '18px',
            'fontWeight': 'normal',
            'textOverflow': 'ellipsis'
          },
          squareSymbol: true,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 0,
          labelFormatter: function () {
            if (this.index !== 2) {
              return this.name + ' %';
            } else {
              return this.name;
            }
          }
        },
        series: [

          {
            type: 'areaspline',
            color: 'var(--v-graphLineColor-base)',
            fillColor: 'transparent',
            tooltip: {
              valueSuffix: ' %',
              headerFormat: '{point.x:%e/%m/%Y}<br>',
            },
            data: this.fundingRateHistory,
            marker: {
              fillColor: 'white',
              lineWidth: 2,
              lineColor: 'var(--v-graphLineColor-base)',
            },
            stickyTracking: false,
          },
        ]
      },
    };
  },
  components: {
    LottieAnimation,
    TimeFrame,
    highcharts: Chart,
    CustomSelect,
  },
  watch: {
    type() {
      this.symbol = this.type
      this.getFundingRateHistory();
    },

    dimension() {
      this.getFundingRateHistory();
    },

    '$route.query.page': {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.page = newVal;
          this.getFundingRateHistory();
        } else {
          this.page = 1;
        }
      }
    },
  },
  methods: {
    ...mapActions({
      getFundingRateHistoryData: 'tradingData/getFundingRateHistory',
    }),

    max(list) {
      return list.reduce((a, b) => a > b ? a : b);
    },

    min(list) {
      return list.reduce((a, b) => a < b ? a : b);
    },

    linkGen(pageNum) {
      // return pageNum === 1 ? '?' : `?page=${pageNum}`
      return {
        path: '/trading-data/funding-rate-history',
        query: { page: pageNum }
      };
    },

    formatter: function (value) {
      return moment.utc(value).local().format('DD/MM/yy  HH:mm');
    },

    getFundingRateHistory() {
      this.isLoading = true;
      this.fundingRateHistoryDataTime = [];
      this.fundingRateHistory = [];
      this.getFundingRateHistoryData({
        symbol: this.symbol,
        timeScope: this.dimension,
      }).then(res => {
        this.fundingRateHistoryData = res.data;

        if (this.fundingRateHistoryData.length) {

          this.fundingRateHistoryData.forEach(el => {
            el.interestRate = 0.1
            this.fundingRateHistory.push(el.fundingRate);
            this.fundingRateHistoryDataTime.push(el.time);
          });

          this.chartOptionsFundingRateHistory.xAxis[0].categories = this.fundingRateHistoryDataTime;
          this.chartOptionsFundingRateHistory.yAxis[0].min = this.min(this.fundingRateHistory);
          this.chartOptionsFundingRateHistory.yAxis[0].max = this.max(this.fundingRateHistory);
          this.chartOptionsFundingRateHistory.series[0].data = this.fundingRateHistory;
          this.chartOptionsFundingRateHistory.series[0].name = this.symbol.split('_').join('/').toUpperCase();
        }

        this.isLoading = false;
      });
    }
  },

  mounted() {
    this.page = this.$route.query.page || 1;
    this.getFundingRateHistory();
  }
};
</script>

<style scoped>
.chart-item-container {
  margin-top: 40px;
  display: flex;
  align-items: center;
  gap: 40px;
  font-size: 20px;
}

.content-wrapper {
  position: relative;
  min-height: 200px;
}

.chart-item-table {
  margin-top: 55px;
}

.chart-item-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
  line-height: 24px;
}

.chart-item-table thead {
  border-top: 1px solid var(--v-loginDropduwnHoverBackgroundColor-base);
  border-bottom: 1px solid var(--v-loginDropduwnHoverBackgroundColor-base);
  text-align: left;
  color: var(--v-tableSecondaryColor-base);
}

.chart-item-table th {
  padding: 12px 0;
}

/*.chart-item-table tbody::before {*/
/*  content: "";*/
/*  display: block;*/
/*  height: 20px;*/
/*}*/
.chart-item-table tbody tr {
  font-size: 12px;
  /* border-bottom: 30px solid transparent; */
  color: var(--v-selectColor-base);
}


.chart-item-table th,
.chart-item-table td {
  width: 25%;
  font-size: 16px;
  line-height: 24px;
  vertical-align: baseline;
}

.chart-item-table tbody td {

}

/*.chart-item-table tbody td:first-child {*/
/*  padding-right: 10px;*/
/*  font-size: 14px;*/
/*  font-weight: 400;*/
/*}*/

.chart-item-table tbody td:nth-child(3n):after {
  content: " %";
  color: var(--v-tableSecondaryColor-base);
}

.preloader-overlay {
  background-color: transparent;
}

.holder-not-logged-text {
  color: #A4A5AF;
}

@media (max-width: 500px) {
  .chart-item-container {
    flex-direction: column;
    align-items: flex-start;
  }
}

.chart-item-container > div {
  position: relative;
  width: 200px;
}

.funding-time {
  text-align: left;
  padding-left: 16px;
}

.funding-interval {
  text-align: right;
}

.interest-rate {
  text-align: right;
}

.funding-rate {
  text-align: right;
  padding-right: 16px;
}

.chart-item-table th.funding-time {
  padding-left: 16px;
}

.chart-item-table th.funding-rate {
  padding-right: 16px;
}


.chart-item-table td.funding-rate {
  color: #42e8e0;
}

.chart-item-table tbody td:nth-child(4):after {
  content: " %";
  color: var(--v-tableSecondaryColor-base);
}

.chart-item-container .chart-item-filter-item {
  position: relative;
  width: 240px;
}

.report-filter-item-title {
  position: absolute;
  top: -25px;
  left: 0;
}


</style>
